<template>
    <div class="d-flex align-items-center" :class="c_noInfo ? 'text-danger':null">
        <span v-if="c_noInfo" class="material-icons-round mr-50">warning</span>
        {{row.Plate}}
    </div>
</template>

<script>
export default {
    props:{
        row:Object,
    },
    computed:{
        c_noInfo(){
            return this.row?.Plate == "Bilgi Yok" ? true : false
        }
    }
}
</script>

<style>

</style>